import { Button } from '@ordr-as/umami-react'
import Spinner from 'components/Spinner'
import { usePaymentOperations } from './context/PaymentOperationsContext'

export const RefreshButton = () => {
    const { refreshData, isRefreshing, cancelRefresh } = usePaymentOperations()

    const refresh = () => {
        if (isRefreshing) {
            cancelRefresh()
            return
        }

        refreshData()
    }

    return (
        <Button kind="tertiary" onClick={refresh}>
            Refresh
            {isRefreshing && (
                <>
                    {'ing...'} <Spinner className="ml-2" size={'extra-small'}></Spinner>
                </>
            )}
        </Button>
    )
}
